import css from "./PlayerStats.module.css";

type Character = {
  charName: string;
  baseClass?: number;
  classId?: number | null;
  curCp?: number | null;
  curHp?: number | null;
  curMp?: number | null;
  maxCp?: number | null;
  maxHp?: number | null;
  maxMp?: number | null;
  con?: number | null;
  crit?: number | null;
  dex?: number | null;
  accuracy?: number | null;
  evasion?: number | null;
  exp?: number | null;
  int?: number | null;
  karma?: number | null;
  level?: number | null;
  mAtk?: number | null;
  mDef?: number | null;
  mSpd?: number | null;
  maxload?: number | null;
  load?: number | null;
  men?: number | null;
  pAtk?: number | null;
  pDef?: number | null;
  pSpd?: number | null;
  pkkills?: number | null;
  pvpkills?: number | null;
  runSpd?: number | null;
  sp?: number | null;
  str?: number | null;
  walkSpd?: number | null;
  wit?: number | null;
  evalscore?: number | null;
  reqremaining?: number | null;
};

export function PlayerStats(params: { character: Character }) {
  const { character } = params;
  return (
    <div className={css.root}>
      <div className={css.title}>Player Stats</div>
      <div>
        <div>
          <div
            style={{
              color: "#fff",
              fontSize: 15,
              fontWeight: 600,
              marginBottom: 2,
            }}
          >
            {character.charName}
          </div>
          <div className={css.columns} style={{ marginBottom: 7 }}>
            <div>Clan</div>
            <div style={{ color: "#fff" }}>No Clan</div>
          </div>
          <div className={css.columns}>
            <div className={css.columns}>
              <div>Lv</div>
              <div className={css.value}>
                {`${character.level} ${prof[character.classId ?? 0]}`}
              </div>
            </div>
            <div className={css.columns}>
              <div>Status</div>
              <div className={css.value}>Vegabond</div>
            </div>
            <div className={css.bars}>
              <div className={css.columns}>
                <div>HP</div>
                <div>
                  <Bar
                    color="#b50018"
                    value={[character.maxHp ?? 0, character.curHp ?? 0]}
                  />
                </div>
              </div>

              <div className={css.columns}>
                <div>MP</div>
                <div>
                  <Bar
                    color="#0060ce"
                    value={[character.maxMp ?? 0, character.curMp ?? 0]}
                  />
                </div>
              </div>

              <div className={css.columns}>
                <div>Exp</div>
                <div>
                  <Bar
                    color="#a598bb"
                    value={[exp[character.level ?? 1], character.exp ?? 1]}
                    type="per"
                  />
                </div>
              </div>
            </div>
            <div className={css.bars}>
              <div className={css.columns}>
                <div>CP</div>
                <div>
                  <Bar
                    color="#c38e39"
                    value={[character.maxCp ?? 0, character.curCp ?? 0]}
                  />
                </div>
              </div>
              <div className={css.columns}>
                <div>W</div>
                <div>
                  <Bar
                    color="#d3aa00"
                    value={[character.maxload ?? 1, character.load ?? 1]}
                    type="per"
                  />
                </div>
              </div>
              <div className={css.columns}>
                <div>SP</div>
                <div className={css.value}>{character.sp ?? 0}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Combat {...params} />
      <Basic {...params} />
      <Social {...params} />
    </div>
  );
}

function Bar(params: {
  color: string;
  value: [number, number];
  type?: "diff" | "per";
}) {
  const { value } = params;
  const type = params.type ?? "diff";
  const percent = Math.round((value[1] / value[0]) * 100 * 100) / 100 + "%";
  return (
    <div className={css.bar}>
      <div
        className={css.max}
        style={{ background: params.color, opacity: 0.4 }}
      ></div>
      <div
        className={css.cur}
        style={{ background: params.color, width: percent }}
      ></div>
      <div className={css.count}>
        {type === "diff" ? `${value[1]}/${value[0]}` : percent}
      </div>
    </div>
  );
}

function Combat(params: { character: Character }) {
  const { character } = params;
  return (
    <div className={css.stats} style={{ marginTop: 10 }}>
      <div
        style={{
          color: "#fff",
          fontSize: 13,
          fontWeight: 600,
          marginBottom: 2,
        }}
      >
        Combat
      </div>
      <div className={css.columns}>
        <div className={css.columns}>
          <div>P. Atk.</div>
          <div className={css.value}>{character.pAtk}</div>
        </div>
        <div className={css.columns}>
          <div>M. Atk.</div>
          <div className={css.value}>{character.mAtk}</div>
        </div>
        <div className={css.columns}>
          <div>P. Def.</div>
          <div className={css.value}>{character.pDef}</div>
        </div>
        <div className={css.columns}>
          <div>M. Def.</div>
          <div className={css.value}>{character.mDef}</div>
        </div>
        <div className={css.columns}>
          <div>Accuracy</div>
          <div className={css.value}>{character.accuracy}</div>
        </div>
        <div className={css.columns}>
          <div>Evasion</div>
          <div className={css.value}>{character.evasion}</div>
        </div>
        <div className={css.columns}>
          <div>Critical</div>
          <div className={css.value}>{character.crit}</div>
        </div>
        <div className={css.columns}>
          <div>Speed</div>
          <div className={css.value}>{character.runSpd}</div>
        </div>
        <div className={css.columns}>
          <div>Atk. Spd.</div>
          <div className={css.value}>{character.pSpd}</div>
        </div>
        <div className={css.columns}>
          <div>Casting. Spd.</div>
          <div className={css.value}>{character.mSpd}</div>
        </div>
      </div>
    </div>
  );
}

function Basic(params: { character: Character }) {
  const { character } = params;
  return (
    <div className={css.basic} style={{ marginTop: 10 }}>
      <div
        style={{
          color: "#fff",
          fontSize: 13,
          fontWeight: 600,
          marginBottom: 2,
        }}
      >
        Basic
      </div>
      <div className={css.columns}>
        <div className={css.sColumns}>
          <div>STR</div>
          <div className={css.value}>{character.str}</div>
        </div>
        <div className={css.sColumns}>
          <div>DEX</div>
          <div className={css.value}>{character.dex}</div>
        </div>
        <div className={css.sColumns}>
          <div>CON</div>
          <div className={css.value}>{character.con}</div>
        </div>
        <div className={css.sColumns}>
          <div>INT</div>
          <div className={css.value}>{character.int}</div>
        </div>
        <div className={css.sColumns}>
          <div>WIT</div>
          <div className={css.value}>{character.wit}</div>
        </div>
        <div className={css.sColumns}>
          <div>MEN</div>
          <div className={css.value}>{character.men}</div>
        </div>
      </div>
    </div>
  );
}

function Social(params: { character: Character }) {
  const { character } = params;
  return (
    <div className={css.social} style={{ marginTop: 10 }}>
      <div
        style={{
          color: "#fff",
          fontSize: 13,
          fontWeight: 600,
          marginBottom: 2,
        }}
      >
        Social
      </div>
      <div className={css.columns}>
        <div className={css.columns}>
          <div>Karma</div>
          <div className={css.value}>{character.karma}</div>
        </div>
        <div className={css.columns}>
          <div>PvP/PK</div>
          <div className={css.value}>{`${
            character.pvpkills
          }/${character.pkkills}`}</div>
        </div>
        <div className={css.columns}>
          <div>Eval. Score</div>
          <div className={css.value}>{character.evalscore}</div>
        </div>
        <div className={css.columns}>
          <div>Rec. Remaining</div>
          <div className={css.value}>{character.reqremaining}</div>
        </div>
      </div>
    </div>
  );
}

function parseValue(value: string | null) {
  return value ? parseInt(value) : 0;
}

const exp: Record<number, number> = {
  1: 0,
  2: 68,
  3: 295,
  4: 805,
  5: 1716,
  6: 3154,
  7: 5249,
  8: 8136,
  9: 11955,
  10: 16851,
  11: 22973,
  12: 30475,
  13: 39516,
  14: 50261,
  15: 62876,
  16: 77537,
  17: 94421,
  18: 113712,
  19: 135596,
  20: 160266,
  21: 187922,
  22: 218762,
  23: 252997,
  24: 290836,
  25: 332497,
  26: 378201,
  27: 428173,
  28: 482647,
  29: 541857,
  30: 606042,
  31: 67545,
  32: 75033,
  33: 830937,
  34: 917531,
  35: 1010378,
  36: 1109744,
  37: 1215906,
  38: 1329143,
  39: 1449736,
  40: 1577978,
  41: 1714158,
  42: 1858578,
  43: 2011538,
  44: 2173347,
  45: 2344318,
  46: 2524767,
  47: 2715019,
  48: 2915398,
  49: 3126237,
  50: 3347873,
  51: 5370971,
  52: 5737357,
  53: 6121498,
  54: 6523923,
  55: 6945178,
  56: 9847742,
  57: 10461823,
  58: 11103227,
  59: 11772715,
  60: 12471057,
  61: 19798547,
  62: 20936137,
  63: 22120557,
  64: 23353014,
  65: 24634736,
  66: 34622619,
  67: 36467935,
  68: 38383956,
  69: 40372393,
  70: 42434976,
  71: 44573456,
  72: 58487000,
  73: 73627796,
  74: 90058594,
  75: 107843995,
  76: 127050464,
  77: 220000006,
  78: 360000000,
  79: 587999998,
  80: 2100724168,
  81: 2100000000,
  82: 1900000000,
  83: 3644000000,
  84: 3628880000,
  85: 4354560000,
};

const prof: Record<number, string> = {
  0: "Human Fighter",
  1: "Warrior",
  2: "Gladiator",
  3: "Warlord",
  4: "Human Knight",
  5: "Paladin",
  6: "Dark Avenger",
  7: "Rogue",
  8: "Treasure Hunter",
  9: "Hawkeye",
  10: "Human Mystic",
  11: "Human Wizard",
  12: "Sorceror",
  13: "Necromancer",
  14: "Warlock",
  15: "Cleric",
  16: "Bishop",
  17: "Prophet",
  88: "Duelist",
  89: "Dreadnought",
  90: "Phoenix Knight",
  91: "Hell Knight",
  92: "Sagittarius",
  93: "Adventurer",
  94: "Archmage",
  95: "Soultaker",
  96: "Arcana Lord",
  97: "Cardinal",
  98: "Hierophant",
  18: "Elven Fighter",
  19: "Elven Knight",
  20: "Temple Knight",
  21: "Swordsinger",
  22: "Elven Scout",
  23: "Plainswalker",
  24: "Silver Ranger",
  25: "Elven Mystic",
  26: "Elven Wizard",
  27: "Spellsinger",
  28: "Elemental Summoner",
  29: "Elven Oracle",
  30: "Elven Elder",
  99: "Eva Templar",
  100: "Sword Muse",
  101: "Wind Rider",
  102: "Moonlight Sentinel",
  103: "Mystic Muse",
  104: "Elemental Master",
  105: "Eva Saint",
  31: "Dark Fighter",
  32: "Palus Knight",
  33: "Shillien Knight",
  34: "Bladedancer",
  35: "Assassin",
  36: "Abyss Walker",
  37: "Phantom Ranger",
  38: "Dark Mystic",
  39: "Dark Wizard",
  40: "Spellhowler",
  41: "Phantom Summoner",
  42: "Shillien Oracle",
  43: "Shillien Elder",
  106: "Shillien Templar",
  107: "Spectral Dancer",
  108: "Ghost Hunter",
  109: "Ghost Sentinel",
  110: "Storm Screamer",
  111: "Spectral Master",
  112: "Shillien Saint",
  44: "Orc Fighter",
  45: "Orc Raider",
  46: "Destroyer",
  47: "Monk",
  48: "Tyrant",
  49: "Orc Mystic",
  50: "Orc Shaman",
  51: "Overlord",
  52: "Warcryer",
  113: "Titan",
  114: "Grand Khavatari",
  115: "Dominator",
  116: "Doomcryer",
  53: "Dwarven Fighter",
  54: "Scavenger",
  55: "Bounty Hunter",
  56: "Artisan",
  57: "Warsmith",
  117: "Fortune Seeker",
  118: "Maestro",
  123: "MaleSoldier",
  124: "Female Soldier",
  125: "Dragoon",
  126: "Warder",
  127: "Berserker",
  128: "MaleSoul Breaker",
  129: "Female Soul Breaker",
  130: "Arbalester",
  131: "Doombringer",
  132: "Male Soul Hound",
  133: "Female Soul Hound",
  134: "Trickster",
  135: "Inspector",
  136: "Judicator",
};
